import { FC, useCallback } from 'react'

import type { Space } from 'features/space/types/spaceDetail'

import space_styles from './AddressTopSection.module.scss'

type Props = {
  space: Space
}

/** Google Maps 流入時にタイトル直下へ表示する住所ブロック (Hotfix-532)。 */
export const AddressTopSection: FC<Props> = ({ space }) => {
  const handleViewOnGoogleMap = useCallback(() => {
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${space.latitude},${space.longitude}`
    )
  }, [space.latitude, space.longitude])

  return (
    <div className={`${space_styles.adressSection} ${space_styles.addressSectionTop}`}>
      <div className={`${space_styles.adressSectionLabel} ${space_styles.addressSectionTopLabel}`}>
        <img src="/adress_icon.svg" alt="" height="24px" width="24px" />
      </div>
      <div
        className={`${space_styles.adressSectionDetail} ${space_styles.addressSectionTopDetail}`}
      >
        <p onClick={handleViewOnGoogleMap} className={space_styles.adress}>
          {space.localed_address}
        </p>
      </div>
    </div>
  )
}
